import { uniqueId } from "lodash";
import { Component } from "react";
import { OutreachDataFilterType } from "../../enumerations";
import { QESRadioButton } from "@app/shared/qes-standards";

interface SelectDataFilterProps {
  testIdPrefix: string; // Used for the testId
  onDataSelectionChange: (dataSelection: OutreachDataFilterType) => void;
  dataSelection: OutreachDataFilterType;
}

export default class SelectDataFilter extends Component<SelectDataFilterProps> {
  private readonly testId = `outreach-export-${this.props.testIdPrefix}__data-select`;
  private readonly radioGroupName = uniqueId("outreach-data-group");

  public render() {
    return (
      <>
        <p className="lead mb0 font-weight-bold">Outreach Data Filter</p>
        <div className="form-group row">
          <div className="col-lg-12">
            <p>Please select the practitioner and service location data to include:</p>
            <div>
              <QESRadioButton
                label="All"
                name={this.radioGroupName}
                testId={this.testId + "-" + OutreachDataFilterType.All}
                value={OutreachDataFilterType.All}
                checked={this.props.dataSelection === OutreachDataFilterType.All}
                onChange={() => { this.props.onDataSelectionChange(OutreachDataFilterType.All); }}
              />
            </div>
            <div>
              <QESRadioButton
                label="Inactive"
                name={this.radioGroupName}
                testId={this.testId + "-" + OutreachDataFilterType.Inactive}
                value={OutreachDataFilterType.Inactive}
                checked={this.props.dataSelection === OutreachDataFilterType.Inactive}
                onChange={() => { this.props.onDataSelectionChange(OutreachDataFilterType.Inactive); }}
              />
            </div>
            <div>
              <QESRadioButton
                label="Exclusions"
                name={this.radioGroupName}
                testId={this.testId + "-" + OutreachDataFilterType.Exclusions}
                value={OutreachDataFilterType.Exclusions}
                checked={this.props.dataSelection === OutreachDataFilterType.Exclusions}
                onChange={() => { this.props.onDataSelectionChange(OutreachDataFilterType.Exclusions); }}
              />
            </div>
          </div>
        </div>
      </>
    );
  }
}